import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { fetchingTasks } from '~/Redux/Modules/Tasks';
import TextInput from '~/Components/Global/Form/TextInput';
import Edit from '~/Components/Global/Assets/Svgs/Edit';
import { titlesForSections, updateSectionTitle } from '~/Redux/Modules/UserOptions';
import Spinner from '~/Components/Global/Loading/Spinner';
import { TYPES } from '~/Config/Checklists';

const TaskListHeader = ({ type, heading, suffix, editable, isSectionCollapsed }) => {
  const sectionTitles = useSelector(titlesForSections);
  const userOptionsId = useSelector(({ UserOptions }) => UserOptions?.data?.id);
  const [editingTitle, setEditingTitle] = useState(false);
  const [title, setTitle] = useState();
  useEffect(() => {
    setTitle(sectionTitles?.[type]);
  }, [sectionTitles, type]);
  const dispatch = useDispatch();
  const isFetching = useSelector(fetchingTasks)[type] ?? false;

  const handleTitleSave = () => {
    setEditingTitle(false);
    dispatch(updateSectionTitle(userOptionsId, type, title));
  };

  const handleTitleKeyDown = ({ keyCode }) => {
    if (keyCode !== 13) return;
    handleTitleSave();
  };

  if (editingTitle) {
    return (
      <TextInput
        className="minimal-input"
        name="currentTitle"
        value={title}
        autoFocus
        onBlur={handleTitleSave}
        onKeyDown={handleTitleKeyDown}
        onChange={change => setTitle(change.currentTitle)}
      />
    );
  }

  return (
    <>
      <span
        className={cn({
          'list-title': !isSectionCollapsed,
          'list-title-collapsed': isSectionCollapsed,
        })}
      >
        {(title || heading)?.length > 80
          ? `${(title || heading).slice(0, 80)}...`
          : title || heading}{' '}
        {suffix}
      </span>
      {isFetching && <Spinner />}
      {editable && !isFetching && (
        <span className="edit-list-title" onClick={() => setEditingTitle(true)}>
          <Edit />
        </span>
      )}
    </>
  );
};

TaskListHeader.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  heading: PropTypes.string.isRequired,
  suffix: PropTypes.string,
  editable: PropTypes.bool,
  isSectionCollapsed: PropTypes.bool,
};

export default TaskListHeader;
